import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-307a273b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1))
const _hoisted_6 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Số vào viện", -1))
const _hoisted_8 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Năm sinh", -1))
const _hoisted_10 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1))
const _hoisted_12 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CMT/CCCD (nếu có)", -1))
const _hoisted_14 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Địa chỉ", -1))
const _hoisted_16 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Ngày yêu cầu", -1))
const _hoisted_18 = { class: "p-field p-col-12 p-md-3 p-lg-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Số phiếu yêu cầu", -1))
const _hoisted_20 = { class: "p-field p-col-12 p-md-12 p-lg-12" }
const _hoisted_21 = { class: "p-field p-col-12 p-md-12 p-lg-12" }
const _hoisted_22 = { class: "p-field p-col-12 p-md-12 p-lg-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Kết quả:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_lv = _resolveComponent("lv")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Kết quả cận lâm sàn" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_InputText, {
                    id: "fullname",
                    type: "text",
                    modelValue: $setup.subclinicalResults.tenBenhNhan,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.subclinicalResults.tenBenhNhan) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_InputText, {
                    id: "number",
                    type: "text",
                    modelValue: $setup.subclinicalResults.soVaoVien,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.subclinicalResults.soVaoVien) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_InputText, {
                    id: "birthday",
                    type: "text",
                    modelValue: $setup.subclinicalResults.namSinh,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.subclinicalResults.namSinh) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_InputText, {
                    id: "weight",
                    type: "text",
                    modelValue: $setup.subclinicalResults.soDienThoai,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.subclinicalResults.soDienThoai) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_InputText, {
                    id: "cmnd",
                    type: "text",
                    modelValue: $setup.subclinicalResults.cmnd,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.subclinicalResults.cmnd) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_InputText, {
                    id: "diachi",
                    type: "text",
                    modelValue: $setup.subclinicalResults.diaChi,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.subclinicalResults.diaChi) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_InputText, {
                    id: "dodienthoai",
                    type: "text",
                    modelValue: $setup.date,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.date) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_InputText, {
                    id: "sophieuyeucau",
                    type: "text",
                    modelValue: $setup.subclinicalResults.soPhieuYeuCau,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.subclinicalResults.soPhieuYeuCau) = $event)),
                    style: {"text-align":"center"}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listSubclinicalResults, (sub) => {
                  return (_openBlock(), _createBlock(_component_lv, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("label", null, "Tên nhóm dịch vụ: " + _toDisplayString(sub.tenNhomDichVu), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createVNode(_component_DataTable, {
                              value: sub.chiTietKetQua,
                              showGridlines: "",
                              responsiveLayout: "scroll"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "noiDungCap_1",
                                  header: "Nội dung cấp 1"
                                }),
                                _createVNode(_component_Column, {
                                  field: "noiDungCap_2",
                                  header: "Nội dung cấp 2"
                                }),
                                _createVNode(_component_Column, {
                                  field: "noiDungCap_3",
                                  header: "Nội dung cấp 3"
                                }),
                                _createVNode(_component_Column, {
                                  field: "noiDung",
                                  header: "Nội dung"
                                }),
                                _createVNode(_component_Column, {
                                  field: "ketQua",
                                  header: "Kết quả"
                                }),
                                _createVNode(_component_Column, {
                                  field: "dvt",
                                  header: "Đơn vị tính"
                                })
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}